import React from "react";
import Header from "../components/Header/Header";
import Navbar from "../components/Navbar/Navbar";
import Committee from "../components/Committee/Committee";
import avatar from "../components/assets/avatar.png";
import narender from "../components/assets/narendra.png";
import dipankar from "../components/assets/dipankar.png";
import syamal from "../components/assets/syamal.png";
import amit from "../components/assets/amit.png";
import s5 from "../components/assets/s5.png";
import n1 from "../components/assets/n1.png";
import n2 from "../components/assets/n2.png";
import n3 from "../components/assets/n3.png";
import n4 from "../components/assets/n4.png";
import n5 from "../components/assets/n5.png";
import n6 from "../components/assets/n6.png";
import n7 from "../components/assets/n7.png";
import n8 from "../components/assets/n8.png";
import n9 from "../components/assets/n9.png";
import n10 from "../components/assets/n10.png";
import n11 from "../components/assets/n11.png";
import n12 from "../components/assets/n12.png";
import n13 from "../components/assets/n13.png";
import n14 from "../components/assets/n14.png";
import n15 from "../components/assets/n15.png";
import n16 from "../components/assets/n16.png";
import n17 from "../components/assets/n17.png";
import n18 from "../components/assets/n18.png";
import n19 from "../components/assets/n19.png";
import n20 from "../components/assets/n20.png";
import n21 from "../components/assets/n21.png";


const NationalAdvisoryCommittee = () => {
  const committeeMembers = [
    {
      name: "Prof. N.K. Mehra",
      designation: "Former Dean (Res) and National Chair, AIIMS, New Delhi",
      role: "",
      imageUrl: narender,
    },
    {
      name: "Prof. GP Talwar",
      designation: "Managing Trustee, Immunology Foundation, New Delhi",
      role: "",
      imageUrl: n1,
    },
    {
      name: "Prof. N.K. Ganguly",
      designation: "Former Director General, ICMR, New Delhi",
      role: "",
      imageUrl: n2,
    },
    {
      name: "Prof. Javed Agrewala",
      designation: "Prof.,Indian Institute of Technology  Ropar",
      role: "",
      imageUrl: s5,
    },
    {
      name: "Prof. S.K. Arora",
      designation: "Department of Immunopathology and Head Department of Translational & Regenerative Medicine, PGIMER, Chandigarh",
      role: "",
      imageUrl: n3,
    },
    {
      name: "Prof. Rajiv Bahl",
      designation: "Director-General, Department of Health Research, ICMR, New Delhi",
      role: "",
      imageUrl: n4,
    },
    {
      name: "Prof. Shashi Baruah",
      designation: "Ex-Professor, Tezpur University, Assam",
      role: "",
      imageUrl: n5,
    },
    {
      name: "Prof. S.V. Chiplunkar",
      designation: "Ex-Director, ACTREC, Navi Mumbai",
      role: "",
      imageUrl: n6,
    },
    {
      name: "Prof. Nibhriti Das",
      designation: "Ex-Professor, Department of Biochemistry, AIIMS, New Delhi",
      role: "",
      imageUrl: n7,
    },
    
    {
      name: "Prof. S. N. Das",
      designation: "Ex-Professor, Department of Biotechnology, AIIMS, New Delhi",
      role: "",
      imageUrl: n8,
    },
    {
      name: "Prof. Santosh Kar",
      designation: "Ex-Professor, Jawaharlal Nehru University (JNU), New Delhi",
      role: "",
      imageUrl: n9,
    },
    {
      name: "Dr. Taruna Madan",
      designation: "Scientist F and Head, Department of Innate Immunity, NIRRH (ICMR), Mumbai, India",
      role: "",
      imageUrl: n10,
    },
    {
      name: "Prof. A.N. Malviya",
      designation: "Ex-HoD, Department of Medicine, AIIMS, New Delhi",
      role: "",
      imageUrl: n11,
    },
    {
      name: "Prof. V.R. Muthukkaruppan",
      designation: "Ex-HoD, Department of Immunology, MKU, Madurai",
      role: "",
      imageUrl: n12,
    },
    {
      name: "Prof. Sita Naik",
      designation: "Ex-HoD, Dept of Immunology, SGPGI, Lucknow",
      role: "",
      imageUrl: n13,
    },
    {
      name: "Prof. Dipankar Nandi",
      designation: "Department of Biochemistry, IISc, Bangalore",
      role: "",
      imageUrl: dipankar,
    },
    {
      name: "Prof. H. Krishna Prasad",
      designation: "Ex-Professor, Department of Biotechnology, AIIMS, New Delhi",
      role: "",
      imageUrl: n15,
    },
    {
      name: "Prof. D.N. Rao",
      designation: "Ex-HoD, Department of Biochemistry, AIIMS, New Delhi",
      role: "",
      imageUrl: n16,
    },
    {
      name: "Prof. Syamal Roy",
      designation: "ICMR-Emeritus Scientist, Indian Institute of Chemical Biology, Kolkata",
      role: "",
      imageUrl: syamal,
    },
    {
      name: "Prof. Krishna Sainis",
      designation: "Ex-Professor, Homi Bhabha National Institute, Maharashtra",
      role: "",
      imageUrl: n17,
    },
    {
      name: "Prof. Shobha Sehgal",
      designation: "Ex-HoD, Department of Immunopathology - PGI, Chandigarh",
      role: "",
      imageUrl: n18,
    },
    {
      name: "Prof. U. Sengupta",
      designation: "Former Director, ICMR, New Delhi",
      role: "",
      imageUrl: n19,
    },
    {
      name: "Prof. Pawan Sharma",
      designation: "Adjunct Professor, IISER, Bhopal",
      role: "",
      imageUrl: n20
    },
    {
      name: "Prof. L.M. Srivastava",
      designation: "Ex-HoD, Department of Biochemistry, AIIMS, New Delhi",
      role: "",
      imageUrl: n21
    },
    {
      name: "Prof. Amit Awasthi",
      designation: "Senior Professor, Translational Health Science and Technology Institute, New Delhi, President, IIS",
      role: "",
      imageUrl: amit,
    }
  ];

  return (
    <>
      <Header />
      <Navbar />
      <Committee heading="National Advisory Committee" people={committeeMembers} />
    </>
  );
};

export default NationalAdvisoryCommittee;
